import { makeStyles } from "tss-react/mui";
import { alpha } from "@mui/material/styles";

export const useStyles = makeStyles<{ isUserResult: boolean }>()(
  (theme, { isUserResult }) => ({
    container: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: theme.spacing(2),
      marginBottom: theme.spacing(2),
      padding: theme.spacing(3, 7),
      backgroundColor: isUserResult
        ? alpha(theme.palette.secondary.main, 0.2)
        : "#ffffff",
      borderRadius: 10,
      [theme.breakpoints.down("md")]: {
        padding: theme.spacing(3),
      },
    },
    contentLeft: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(3),
    },
    rank: {
      width: "3em",
      display: "flex",
      justifyContent: "center",
      [theme.breakpoints.down("md")]: {
        width: "2em",
      },
    },
    rankLabel: {
      fontSize: "2.38rem",
      fontWeight: 700,
      [theme.breakpoints.down("xl")]: {
        fontSize: "1.63rem",
      },
      [theme.breakpoints.down("md")]: {
        fontSize: "1.75rem",
      },
    },
    thumbnail: {
      width: 75,
      height: 75,
      minWidth: 75,
      minHeight: 75,
      borderRadius: 5,
      objectFit: "cover",
      [theme.breakpoints.down("md")]: {
        width: 42,
        height: 42,
        minWidth: 42,
        minHeight: 42,
      },
    },
    resultValue: {
      flex: 1,
      fontSize: "1.38rem",
      fontWeight: 500,
      color: theme.palette.primary.main,
      [theme.breakpoints.down("xl")]: {
        fontSize: "1.19rem",
      },
      [theme.breakpoints.down("md")]: {
        fontSize: "1rem",
      },
    },
    score: {
      textAlign: "right",
      fontSize: "2.38rem",
      fontWeight: 700,
      color: isUserResult
        ? theme.palette.secondary.main
        : theme.palette.primary.main,
      [theme.breakpoints.down("xl")]: {
        fontSize: "1.63rem",
      },
      [theme.breakpoints.down("md")]: {
        fontSize: "1.75rem",
      },
    },
    players: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: theme.spacing(1),
    },
    player: {
      margin: theme.spacing(-2),
    },
    additionalPlayers: {
      padding: theme.spacing(1),
      width: 50,
      textAlign: "right",
      fontWeight: 500,
      color: theme.palette.primary.main,
    },
  })
);
